export default "__VITE_ASSET__DDrhef5Y__"